import React from "react";
import wa from "../../images/wa.png";

const Details = ({ data: organization, postCode }) => {
  return (
    <div className="organization-design">
      <div>
        <div className="text-1">{organization.name}</div>
        {organization.logo && (
          <div
            style={{
              display: "flex",
              width: "100%",
              maxHeight: "15vh",
              alignItems: "start",
            }}
          >
            <img
              className="pic1"
              src={`data:image/png;base64,${organization.logo}`}
              alt="Organization Logo"
            />
          </div>
        )}
        <div className="text-2">INFORMACJE O ORGANIZACJI</div>
        <div
          className="long-text"
          dangerouslySetInnerHTML={{
            __html: organization.fullDescription.replace(/\n/g, "<br>"),
          }}
        ></div>
      </div>
      <div className="vertical-line"></div>
      <div style={{ bottom: "0px", marginTop: "1vh" }}>
        <div className="info-container">
          <div className="picture">
            {organization.manager.photo && (
              <img
                src={`data:image/png;base64,${organization.manager.photo}`}
                style={{ height: "8vh", width: "8vh", borderRadius: "50%" }}
              />
            )}
          </div>
          <div className="text-container1">
            <div>
              <b className="title1">KOORDYNATOR</b>
            </div>
            <div>
              {organization.manager.name} {organization.manager.surname}
            </div>
            <a
              className="underline-button"
              href={`tel:+48${organization.manager.phoneNumber}`}
            >
              +48 {organization.manager.phoneNumber}
            </a>
          </div>
        </div>
        {/*<div className="bottom-text">
           Wspólnie tworzymy coś wyjątkowego, co ma realny wpływ na życie innych.
           Razem możemy zdziałać wiele. Dziękuję za możliwość bycia częścią tego
          niezwykłego hospicjum.
         </div>*/}
      </div>
      <div className="part1">
        <div className="text-2">GDZIE ZOSTAWIĆ RZECZY?</div>
        {/*<div className="picture1">
          {organization.photo && (
            <img
              className="picture1_img"
              src={`data:image/png;base64,${organization.photo}`}
            />
          )}
        </div>*/}
        <div className="details_part1">
          <div>
            Adres: ul. {organization.address.streetName}{" "}
            {organization.address.streetNumber},
            {postCode !== null && postCode !== undefined ? " " + postCode : ""}{" "}
            {organization.address.city}
          </div>
          {/* <div>Miejsce: recepcja Hospicjum</div> */}
        </div>
      </div>
      <div className="part2">
        <div className="details_part1">
          <div style={{ marginBottom: "1vh" }}>
            Zanim oddasz w Dobre Ręce skontaktuj się z nami:
          </div>
          <img src={wa} style={{ width: "20px", verticalAlign: "bottom" }} />
          <a
            className="underline-button"
            href={`tel:+48${organization.manager.phoneNumber}`}
          >
            +48 {organization.manager.phoneNumber}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Details;
